$('[data-loadmore]').click(function () {
    const $button = $(this);
    const data = {
        'action': 'loadmore',
        'query': site.posts,
        'page': site.current_page,
    };

    $.ajax({
        url: site.ajaxurl,
        data: data,
        type: 'POST',
        beforeSend: function (xhr) {
            $button.text('Loading...');
            $('.pagination').fadeOut();
        },
        error: function () {
            $('.pagination').fadeIn();
            $button.text('Failed To Load');
        },
        success: function (data) {
            if (data) {
                $button.text('Load More');
                switch ($button.attr('data-loadmore')) {
                    case 'seed':
                        $('.seed-product-table tbody').append(data);
                        break;
                    default:
                        $button.prev().before(data);
                }
                site.current_page++;

                if (site.current_page == site.max_page) {
                    $button.fadeOut();
                }

                $(document.body).trigger('post-load');
            } else {
                $button.fadeOut();
            }
        }
    });
});
